import {
    PENDING, FULFILLED, REJECTED, CITY, STATE, COUNTRY, META_PRODUCT_TYPES, PINCODE, CUSTOMERSELECT,
    ROLE_TYPE, PRODUCT_SELECT, PROJECT_SELECT,
    DEVICE_SELECT,
    ROLES, CUSTOMER_UTILITY_TYPE,
    ALL_STATES, ALL_CITIES, ALL_PINCODES, DEVICE_STATUS_LIST,LOCATIONCATEGORY,CATEGORY,LAMPBRAND, BUILD_NUMBER_TYPES
} from "../../utility/constants";

/**
 * Get the cities - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function cities(data) {
    const { type, ...otherData } = data || {};
    const reqType = type || CITY;
    return {
        types: [`${reqType}_${PENDING}`, `${reqType}_${FULFILLED}`, `${reqType}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/masterdata/cities',
        queryParams: otherData,
        payload: { receiveType: 'masterData' },
    }
}

/**
 * Get the all cities list in single request - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function allCities(data) {
    return {
        types: [`${ALL_CITIES}_${PENDING}`, `${ALL_CITIES}_${FULFILLED}`, `${ALL_CITIES}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/masterdata/cities',
        queryParams: data,
    }
}

/**
 * Get the states - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function states(data) {
    const { type, ...otherData } = data || {};
    const reqType = type || STATE;
    return {
        types: [`${reqType}_${PENDING}`, `${reqType}_${FULFILLED}`, `${reqType}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/masterdata/states',
        queryParams: otherData,
        payload: { receiveType: 'masterData' }
    }
}

/**
 * Get the all states list in single request - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function allStates(data) {
    return {
        types: [`${ALL_STATES}_${PENDING}`, `${ALL_STATES}_${FULFILLED}`, `${ALL_STATES}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/masterdata/states',
        queryParams: data,
    }
}

/**
 * Get the countries - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function countries(data) {
    const { type, ...otherData } = data || {};
    const reqType = type || COUNTRY;
    return {
        types: [`${reqType}_${PENDING}`, `${reqType}_${FULFILLED}`, `${reqType}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/masterdata/countries',
        queryParams: otherData,
        payload: { receiveType: 'masterData' }
    }
}

/**
 * Get the utilities - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function productTypes(data) {
    return {
        types: [`${META_PRODUCT_TYPES}_${PENDING}`, `${META_PRODUCT_TYPES}_${FULFILLED}`, `${META_PRODUCT_TYPES}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/products/meta',
        data: data,
        queryParams: data,
        payload: { receiveType: 'masterData' },
    }
}

/**
 * Get the pincode - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function pincodes(data) {
    const { type, ...otherData } = data || {};
    const reqType = type || PINCODE;
    return {
        types: [`${reqType}_${PENDING}`, `${reqType}_${FULFILLED}`, `${reqType}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/masterdata/pincodes',
        queryParams: otherData,
        payload: { receiveType: 'masterData' }
    }
}

/**
 * Get the all pincodes - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function allPincodes(data) {
    return {
        types: [`${ALL_PINCODES}_${PENDING}`, `${ALL_PINCODES}_${FULFILLED}`, `${ALL_PINCODES}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/masterdata/pincodes',
        queryParams: data,
    }
}

/**
 * Get the customer select - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function customerSelect(data) {
    return {
        types: [`${CUSTOMERSELECT}_${PENDING}`, `${CUSTOMERSELECT}_${FULFILLED}`, `${CUSTOMERSELECT}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/customers/meta',
        data: data,
        queryParams: data,
        payload: { receiveType: 'masterData' }
    }
}
function locationCategory(data) {
    return {
        types: [`${LOCATIONCATEGORY}_${PENDING}`, `${LOCATIONCATEGORY}_${FULFILLED}`, `${LOCATIONCATEGORY}_${REJECTED}`],
        method: 'GET',
        url: 'deviceservice/reports/locationCategory',
        data: data,
        queryParams: data,
        payload: { receiveType: 'masterData' }
    }
}

function category(data) {
    return {
        types: [`${CATEGORY}_${PENDING}`, `${CATEGORY}_${FULFILLED}`, `${CATEGORY}_${REJECTED}`],
        method: 'GET',
        url: 'deviceservice/reports/category',
        data: data,
        queryParams: data,
        payload: { receiveType: 'masterData' }
    }
}

function lampBrand(data) {
    return {
        types: [`${LAMPBRAND}_${PENDING}`, `${LAMPBRAND}_${FULFILLED}`, `${LAMPBRAND}_${REJECTED}`],
        method: 'GET',
        url: 'deviceservice/reports/lampBrandName',
        data: data,
        queryParams: data,
        payload: { receiveType: 'masterData' }
    }
}

/**
 * Get the site select - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
function roleType(data) {
    return {
        types: [`${ROLE_TYPE}_${PENDING}`, `${ROLE_TYPE}_${FULFILLED}`, `${ROLE_TYPE}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/role?page=0&size=1000',
        queryParams: data,
        payload: { receiveType: 'masterData' }
    }
}
/**
 * Get the roles - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
export function getRoles(data) {
    return {
        types: [`${ROLES}_${PENDING}`, `${ROLES}_${FULFILLED}`, `${ROLES}_${REJECTED}`],
        method: 'GET',
        url: `userservice/users/roles`,
        queryParams: data,
        payload: {}
    }
}
/**
 * Get the roles - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
export function customerUtilityType(data) {
    return {
        types: [`${CUSTOMER_UTILITY_TYPE}_${PENDING}`, `${CUSTOMER_UTILITY_TYPE}_${FULFILLED}`, `${CUSTOMER_UTILITY_TYPE}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/customers/utility/' + data.customerId,
        data: data,
        queryParams: data,
        payload: {}
    }
}

/**
 * Get the Device - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
export function deviceSelect(data) {
    return {
        types: [`${DEVICE_SELECT}_${PENDING}`, `${DEVICE_SELECT}_${FULFILLED}`, `${DEVICE_SELECT}_${REJECTED}`],
        method: 'GET',
        url: 'deviceservice/devices?type=all&page=0&size=1000',
        data: data,
        queryParams: data,
        payload: {}
    }
}

/**
 * Get the Device - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
export function productSelect(data) {
    return {
        types: [`${PRODUCT_SELECT}_${PENDING}`, `${PRODUCT_SELECT}_${FULFILLED}`, `${PRODUCT_SELECT}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/products/meta',
        data: data,
        queryParams: data,
        payload: {}
    }
}

/**
 * Get the Device - async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
export function projectSelect(data) {
    return {
        types: [`${PROJECT_SELECT}_${PENDING}`, `${PROJECT_SELECT}_${FULFILLED}`, `${PROJECT_SELECT}_${REJECTED}`],
        method: 'GET',
        url: 'userservice/projects/meta',
        data: data,
        queryParams: data,
        payload: {}
    }
}

/**
 * Get the devices status list async action creators
 * Hanlde the Pending, Fullfilled (Success), Rejected action
 *
 * @return object
 */
export function getDeviceStatusList() {
    const request = {
        types: [`${DEVICE_STATUS_LIST}_${PENDING}`, `${DEVICE_STATUS_LIST}_${FULFILLED}`, `${DEVICE_STATUS_LIST}_${REJECTED}`],
        method: 'GET',
        url: 'deviceservice/devices/status/meta',
    }

    return request;
}

function buildNumbers(data) {
    return {
        types: [`${BUILD_NUMBER_TYPES}_${PENDING}`, `${BUILD_NUMBER_TYPES}_${FULFILLED}`, `${BUILD_NUMBER_TYPES}_${REJECTED}`],
        method: 'GET',
        url: 'deviceservice/firmware/meta',
        data: data,
        queryParams: data,
        payload: { receiveType: 'masterData' },
    }
}

export const masterData = {
    cities,
    states,
    countries,
    productTypes,
    pincodes,
    customerSelect,
    locationCategory,
    category,
    lampBrand,
    projectSelect,
    productSelect,
    roleType,
    getRoles,
    customerUtilityType,
    getDeviceStatusList,
    allPincodes,
    allCities,
    allStates,
    deviceSelect,
    buildNumbers
};
